import type { BennieServices } from './providers/BennieClientProvider';
import { HttpBennieClient } from './clients/http/HttpBennieClient';

/**
 * Create Bennie services for the application.
 *
 * PRD v3 cleanup: Mock client removed. Backend must be running for development.
 * Use `VITE_API_BASE_URL` to point to a different backend if needed.
 */
export function createBennieServices(): BennieServices {
  return {
    api: new HttpBennieClient(),
  };
}


